import CreateNotification from "../../components/Notification/CreateNotification";

const AddNotificationPage = () => {
  return <CreateNotification />;
};

export default AddNotificationPage;
